import React from 'react';
import Modal from 'simple-react-modal';

import './PayPerViewPurchaseModal.css';
import { observer } from 'mobx-react';

import AccountPackages from '../accountComponents/AccountPackages';
import PayPerViewStore from '../../store/PayPerViewStore';
import { buildAnchorLink } from '../../utils/helpers';


@observer
class PayPerViewPurchaseModal extends React.Component {
  constructor(props) {
    super(props);
  }

  closeModal = () => {
    PayPerViewStore.setShowPayPerViewModal(false);
  };

  render() {
    const {
      anchors,
      title,
      price,
      user,
      anchorId,
      buyClip,
      type,
      clipId,
      programs,
      anchorName,
      openPurchased,
      closeModal,
      startPurchaseTimer,
    } = this.props;
    const showModal = PayPerViewStore.showPayPerViewModal;
    const currentAnchor = anchors.find((anchor) => anchor.id === PayPerViewStore.currentlySelectedAnchorID);
    const anchorShortUrl = buildAnchorLink({
      id: (currentAnchor?.id || anchorId),
      name: (currentAnchor?.name || anchorName),
    });

    return (
      <Modal className="pay-per-view-modal-container" closeOnOuterClick={true} show={showModal} onClose={this.closeModal}>
        <div className="pay-per-view-modal">
          {programs.length > 0 ? <AccountPackages
            activeCampaign={{}}
            anchorName={PayPerViewStore.currentlySelectedAnchor || anchorName}
            anchorShortUrl={anchorShortUrl}
            anchorToSubscribe={PayPerViewStore.currentlySelectedAnchorID.toString() || anchorId.toString()}
            buyClip={buyClip}
            clipId={clipId}
            closeModal={closeModal}
            disableOneClickPaysafe={false}
            isGift={false}
            isItem={true}
            message={PayPerViewStore.message}
            openPurchased={openPurchased}
            price={price}
            programs={programs}
            returnPath={`${window.location.pathname}`}
            startPurchaseTimer={startPurchaseTimer}
            title={title}
            type={type}
            user={user}
          /> : null
          }
        </div>
      </Modal>
    );
  }
}

export default PayPerViewPurchaseModal;
